import { jsx as _jsx } from "react/jsx-runtime";
import { useToast as useChakraToast, } from '@chakra-ui/react';
import { Alert } from '@caspeco/casper-ui-library.components.alert';
import { ThemeShadowVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
/**
 * React hook used to create a function that can be used to show toasts in an application.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/toast
 */
export function useToast() {
    const chakraToast = useChakraToast();
    const showToast = ({ type = 'info', duration = 3000, description, title, distanceToBottom, }) => {
        const width = { base: '100%', md: '560px' };
        const pb = distanceToBottom ?? {
            base: '8px',
            md: '48px',
        };
        const containerStyle = {
            maxW: '100%',
            px: '8px',
            minW: width,
            w: width,
            pb,
        };
        // Chakra toast status does not have an option for neutral
        // so we map neutral to status info
        const chakraToastStatus = type === 'neutral' ? 'info' : type;
        chakraToast({
            duration,
            position: 'bottom',
            status: chakraToastStatus,
            isClosable: true,
            render: ({ onClose }) => (_jsx(Alert, { title: title, type: type, onClose: onClose, boxShadow: ThemeShadowVariable.Small, children: description })),
            containerStyle,
        });
    };
    return { showToast };
}
//# sourceMappingURL=toast.js.map